import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiTrendingUp, FiLock, FiBookOpen } from 'react-icons/fi';

const Layout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  if (isAdmin) {
    return (
      <div className="min-h-screen bg-finance-light">
        <header className="bg-finance-blue text-white shadow-md">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
            <Link to="/admin/dashboard" className="flex items-center gap-2 font-bold text-xl">
              <SafeIcon icon={FiLock} className="text-finance-green" />
              <span>Admin Dashboard</span>
            </Link>
            <Link to="/" className="text-sm text-slate-300 hover:text-white transition">
              Zurück zur Webseite
            </Link>
          </div>
        </header>
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {children}
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-finance-light">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-10 h-10 bg-finance-blue rounded flex items-center justify-center group-hover:bg-finance-green transition-colors">
              <SafeIcon icon={FiTrendingUp} className="text-white text-xl" />
            </div>
            <div>
              <h1 className="font-bold text-xl text-finance-blue leading-tight">Dividenden</h1>
              <p className="text-xs text-finance-green font-semibold uppercase tracking-wider">Investor.ch</p>
            </div>
          </Link>
          <nav className="hidden sm:flex items-center gap-8">
            <Link to="/" className="text-sm font-medium text-slate-600 hover:text-finance-green transition">Startseite</Link>
            <a 
              href="https://dividenden-investor.ch" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-sm font-bold text-finance-blue hover:text-finance-green transition"
            >
              <SafeIcon icon={FiBookOpen} /> Das Buch
            </a>
            <Link to="/admin" className="text-sm font-medium text-slate-400 hover:text-finance-green transition">Redaktion</Link>
          </nav>
        </div>
      </header>

      <main className="flex-grow max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 w-full">
        {children}
      </main>

      <footer className="bg-finance-blue text-slate-300 py-12">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <SafeIcon icon={FiTrendingUp} className="text-finance-green text-xl" />
              <span className="font-bold text-white text-lg">Dividenden Investor</span>
            </div>
            <p className="text-sm text-slate-400">
              Unabhängiges Wissen für Investoren im DACH-Raum. Fokus auf Cashflow, Qualität und langfristigen Vermögensaufbau in Deutschland, Österreich und der Schweiz.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-white mb-4">Rechtliches</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://dividenden-investor.ch/#/impressum" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">
                  Impressum
                </a>
              </li>
              <li>
                <a href="https://dividenden-investor.ch/#/datenschutz" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">
                  Datenschutz
                </a>
              </li>
              <li>
                <a href="https://dividenden-investor.ch/#/kontakt" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">
                  Kontakt
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-white mb-4">Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://dividenden-investor.ch" className="hover:text-white transition font-bold text-finance-green">
                  Das Buch kaufen
                </a>
              </li>
              <li><Link to="/admin" className="hover:text-white transition flex items-center gap-2"><SafeIcon icon={FiLock} /> Interner Bereich</Link></li>
            </ul>
          </div>
        </div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-8 border-t border-slate-700 text-sm text-center text-slate-500">
          &copy; {new Date().getFullYear()} Dividenden Investor. Alle Rechte vorbehalten.
        </div>
      </footer>
    </div>
  );
};

export default Layout;